import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import { Dialog } from 'primereact/dialog';

import {
  INewSemenTransactionFormRef,
  NewSemenTransactionForm,
} from '@/components/common/new-semen-transaction-form';
import { NewSemenTransactionFormValues } from '@/components/common/new-semen-transaction-form/schema';
import { Semen } from '@/rtk-query.gql';
import { SemenDto } from '@/services/semen-service/types';

type NewSemenTransactionDialogProps = {
  visible: boolean;
  onHide: () => void;
  semenId: string;
  semen?: Semen | SemenDto;
  onSuccess?: (data: NewSemenTransactionFormValues) => void;
  onError?: (error: unknown) => void;
};

export type INewSemenTransactionDialogRef = {
  submit: () => void;
};

export const NewSemenTransactionDialog = forwardRef<
  INewSemenTransactionDialogRef,
  NewSemenTransactionDialogProps
>(({ visible, onHide, semenId, semen, onSuccess, onError }, ref) => {
  const newFormRef = useRef<INewSemenTransactionFormRef>(null);

  useImperativeHandle(ref, () => ({
    submit: () => {
      newFormRef.current?.submit();
    },
  }));

  return (
    <Dialog
      header="New Semen Transaction"
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
    >
      <NewSemenTransactionForm
        ref={newFormRef}
        semenId={semenId}
        semen={semen}
        onSuccess={onSuccess}
        onError={onError}
        onCancel={onHide}
      />
    </Dialog>
  );
});
